import styles from './widget-properties.module.less';

import type { RequiredPropertyProps } from './types';

type TextPropertyInputProps = RequiredPropertyProps<string> & {
  value: string;
};

export const TextPropertyInput = ({ id, value, updateWidget }: TextPropertyInputProps) => {
  return <input className={styles['input-property']} id={id} onChange={(e) => updateWidget(e.target.value)} value={value} />;
};
